module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-04-9e411fdde5039a6832716db0c73883a2.svg";